import { StyleElement } from '@core/models/style-element';
import { CropResizeConstraints } from './crop-resize-constraints';
import { MultiFieldConfig } from './multi-field-config';
import { MultiFieldContent } from './multi-field-content';
import { MultiFieldImageSource } from './multi-field-image-source';
import { MultiFieldType } from './multi-field-type';

export enum ImageSource {
	None,
	Gallery,
	Upload
}

export class MultiField {
	key: string;
	config: MultiFieldConfig;
	type: MultiFieldType;

	contentItem: MultiFieldContent;

	label?: string;
	description?: string;

	content?: string;

	fileName?: string;      // the name of the loaded file in case of type===IMAGEUPLOAD // OBSOLETE, try to get rid of it
	imageWidth?: number;    // used only when the image width exceeds allowed limit
	imageHeight?: number;   // used only when the image height exceeds allowed limit

	cropResizeConstraints?: CropResizeConstraints;

	constructor(styleElement: StyleElement, cacheItem: MultiFieldContent) {
		this.key = styleElement.key;
		this.config = new MultiFieldConfig(styleElement.metadata);
		this.type = this.getFieldType(styleElement.type, this.config);
		this.contentItem = cacheItem;
		this.label = styleElement.label;
		this.description = styleElement.description;

		if (this.type === MultiFieldType.TEXT || this.type === MultiFieldType.TEXTAREA) {
			if (cacheItem.textContent) {
				this.content = cacheItem.textContent;
			}
		}
		else if (this.type === MultiFieldType.IMAGE) {

			this.cropResizeConstraints = new CropResizeConstraints(this.config);

			if (this.config.allowimagegallery && this.contentItem.imageSource === MultiFieldImageSource.Gallery) {
				this.content = this.contentItem.imageContent;
				this.fileName = this.contentItem.fileName;
			}

			if (this.config.allowimageupload && this.contentItem.imageSource === MultiFieldImageSource.Upload) {
				if (this.doesCachedImageFit()) {
					this.content = this.contentItem.imageContent;
					this.fileName = this.contentItem.fileName;
				}
			}
		}
	}

	setText(textValue: string) {
		this.content = textValue;
		this.contentItem.textContent = textValue;
	}

	setGalleryImage(id?: string, content?: string, fileName?: string): void {
		this.content = content;
		this.fileName = fileName;

		this.contentItem.galleryImageId = id;
		this.contentItem.imageContent = content;
		this.contentItem.fileName = fileName;
		this.contentItem.imageWidth = undefined;
		this.contentItem.imageHeight = undefined;
		this.contentItem.imageSource = MultiFieldImageSource.Gallery;
	}

	setUploadedImage(content?: string, fileName?: string, imageWidth?: number, imageHeight?: number): void {
		this.content = content;
		this.fileName = fileName;

		this.imageWidth = imageWidth;
		this.imageHeight = imageHeight;

		this.contentItem.imageContent = content;
		this.contentItem.fileName = fileName;
		this.contentItem.imageWidth = imageWidth;
		this.contentItem.imageHeight = imageHeight;
		this.contentItem.imageSource = MultiFieldImageSource.Upload;
	}

	removeImage(): void {
		this.content = undefined;
		this.fileName = undefined;

		this.contentItem.galleryImageId = undefined;
		this.contentItem.imageContent = undefined;
		this.contentItem.fileName = undefined;
		this.contentItem.imageWidth = undefined;
		this.contentItem.imageHeight = undefined;
		this.contentItem.imageSource = MultiFieldImageSource.None;
	}

	get imageSource(): MultiFieldImageSource {
		return this.contentItem.imageSource;
	}

	private getFieldType(styleElementType: string | undefined, config: MultiFieldConfig): MultiFieldType {
		if (!styleElementType) {
			// TBD: log error
			throw "The styleElementType is empty";
		}

		let res: MultiFieldType;
		switch (styleElementType.toUpperCase()) {
			case "TEXT":
				if (config.multiline) {
					res = MultiFieldType.TEXTAREA;
				}
				else {
					res = MultiFieldType.TEXT;
				}
				break;
			case "IMAGE":
				res = MultiFieldType.IMAGE;
				break;
			default:
				throw "The styleElementType=\"" + styleElementType + "\" is not supported";
				break;
		}
		return res;
	}

	private doesCachedImageFit(): boolean {
		let res = true;
		if (this.cropResizeConstraints) {

			if (this.contentItem.imageWidth && !this.cropResizeConstraints.isWidthWithinLimits(this.contentItem.imageWidth)) {
				res = false;
			}

			if (this.contentItem.imageHeight && !this.cropResizeConstraints.isHightWithinLimits(this.contentItem.imageHeight)) {
				res = false;
			}
		}

		return res;
	}
}
